module.exports = __webpack_public_path__ + "img/组 6035.5c68ddb7.svg";